/** Pendant zu `Services/API/ApiRechnungenService.cs`. */

import type { Document, Receipt } from '@/types/entities';
import { EntityTypes } from '@/types/enums';

import { createViewApi, fetchDocuments, type ViewApi } from '../apiViewBase';

const ENDPOINT = 'rechnungen';

export const receiptApi: ViewApi<Receipt> & {
  getDocuments(viewId: number, id: number): Promise<Document[]>;
} = {
  ...createViewApi<Receipt>(ENDPOINT, EntityTypes.Rechnung),

  getDocuments: (viewId, id) => fetchDocuments(ENDPOINT, viewId, id),
};
